import { Box, Button } from '@mui/material';
import styled from 'styled-components';
import pallet from '../../../layouts/pallet';

export const SearchInputWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: 16,
  alignItems: 'flex-end'
}));

export const RollNoUpdateContainer = styled(Box)(() => ({
  cursor: 'pointer',
  width: '100%',
  height: '40px',
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    border: `1px solid ${pallet.black}`
  }
}));

export const SearchButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  borderRadius: '8px !important',
  width: '100%',
  '@media (min-width: 600px)': {
    width: 'auto'
  }
});

export const StyledButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  borderRadius: '8px !important'
});

export const CancelButton = styled(Button)({
  width: 'min-content',
  color: `${pallet.black} !important`,
  border: `1px solid ${pallet.black} !important`,
  borderRadius: '8px !important'
});

export const ButtonWrapper = styled(Button)({
  display: 'flex',
  gap: '16px !important',
  justifyContent: 'end !important'
});

export const HeaderWrapper = styled(Box)({
  maxWidth: '95%',
  marginInline: 'auto',
  my: 4
});
